import { resolveBuiltinModule, resolveBuiltinModuleSync } from '@graphql-toolkit/common';
function applyDefaultOptions(options) {
    options.cache = options.cache || {};
    options.cwd = options.cwd || process.cwd();
    options.sort = 'sort' in options ? options.sort : true;
    options.processedFiles = options.processedFiles || new Map();
}
export async function prepareOptions(options) {
    applyDefaultOptions(options);
    options.fs = await resolveBuiltinModule('fs', options.fs);
    options.path = await resolveBuiltinModule('path', options.path);
    options.os = await resolveBuiltinModule('os', options.os);
    return options;
}
export async function prepareOptionsSync(options) {
    applyDefaultOptions(options);
    options.fs = resolveBuiltinModuleSync('fs', options.fs);
    options.path = resolveBuiltinModuleSync('path', options.path);
    options.os = resolveBuiltinModuleSync('os', options.os);
    return options;
}
//# sourceMappingURL=options.js.map